import React, { useContext, useEffect, useState } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { getSyncStats } from '../services/offlineStorage';
import { readSession, STORAGE_CHANGED } from '../services/submissionSession';

export default function PendingCallsNotice() {
  const { user } = useContext(AuthContext), location = useLocation();
  const [count, setCount] = useState(0), [storageError, setStorageError] = useState(''), [updateReady, setUpdateReady] = useState(false);
  useEffect(() => {
    let active = true;
    setCount(0);
    const refresh = async () => {
      if (!user || readSession()?.ownerUserId !== user.id) return;
      try {
        const stats = await getSyncStats();
        if (active && readSession()?.ownerUserId === user.id) { setStorageError(''); setCount(stats.pendingIncidents + stats.syncingIncidents + stats.errorIncidents + stats.queuedOperations); }
      } catch { if (active) setStorageError('Local call storage is unavailable. Keep open forms until storage is restored.'); }
    };
    const blocked = () => setStorageError('Close older CAD tabs to finish the local storage update. Saved work is retained.');
    const update = () => setUpdateReady(true);
    refresh(); window.addEventListener(STORAGE_CHANGED, refresh); window.addEventListener('cad-storage-blocked', blocked); window.addEventListener('cad-update-ready', update);
    return () => { active = false; window.removeEventListener(STORAGE_CHANGED, refresh); window.removeEventListener('cad-storage-blocked', blocked); window.removeEventListener('cad-update-ready', update); };
  }, [user]);
  if (!user) return null;
  return <Snackbar open={Boolean(storageError || count || updateReady) && location.pathname !== '/pending-calls'} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} sx={{ bottom: { xs: '80px !important', sm: '24px !important' }, maxWidth: 'calc(100% - 24px)' }}>
    <Alert severity={storageError ? 'error' : count ? 'warning' : 'info'} action={<Button color="inherit" component={Link} to="/pending-calls">Review</Button>}>
      {storageError || (count ? `${count} saved items await delivery or review on this device.` : 'Update ready. Save open forms, then close and reopen CAD when convenient.')}
    </Alert>
  </Snackbar>;
}
